if (!customElements.get('ssb-collection-carousel')) {
  customElements.define('ssb-collection-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.slides = [...this.querySelectorAll('.ssb-footer-carousel__slide')];
      this.index = 0;
      this.paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.position = this.querySelector('[data-position]');
      this.toggle = this.querySelector('[data-toggle]');
      this.announcement = this.querySelector('[data-announcement]');
      this.querySelectorAll('button').forEach(button => {
        button.disabled = this.slides.length < 2;
        button.addEventListener('click', () => {
          if (button.hasAttribute('data-direction')) {
            this.paused = true;
            this.show(this.index + Number(button.dataset.direction), true);
          } else { this.paused = !this.paused; }
          this.update();
        });
      });
      this.addEventListener('mouseenter', () => { this.hovered = true; });
      this.addEventListener('mouseleave', () => { this.hovered = false; });
      this.addEventListener('focusin', () => { this.focused = true; });
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); });
      this.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault(); this.paused = true;
        this.show(this.index + (event.key === 'ArrowRight' ? 1 : -1), true); this.update();
      });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; });
      this.observer.observe(this);
      this.timer = window.setInterval(() => {
        if (!this.paused && !this.hovered && !this.focused && this.visible && !document.hidden && this.slides.length > 1) this.show(this.index + 1, false);
      }, 6000);
      this.update();
    }
    show(index, announce) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.position.textContent = `${this.index + 1} / ${this.slides.length}`;
      if (announce) this.announcement.textContent = this.slides[this.index].getAttribute('aria-label');
    }
    update() {
      this.toggle.textContent = this.paused ? 'Play' : 'Pause';
      this.toggle.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow');
    }
    disconnectedCallback() { window.clearInterval(this.timer); this.observer?.disconnect(); this.ready = false; }
  });
}
